import { VacationRequestsRepositoryT } from "../../domain/ports/vacationRequests.repository";

type ApplyVacationRequestsParamsT = {
  vacationRequestsRepository: VacationRequestsRepositoryT;
  requestIds: string[];
};

export const applyVacationRequests = async ({
  vacationRequestsRepository,
  requestIds,
}: ApplyVacationRequestsParamsT) => {
  return await vacationRequestsRepository.applyRequests(requestIds);
};
